<template>
  <div class="ui form" ref="form">
    <h4 class="ui dividing header">{{ $t("front end") }}</h4>
    <div class="field">
      <label for="">{{ $t("module name") }}</label>
      <input type="text" name="name" v-model="name" />
    </div>
    <div class="field">
      <label for="">{{ $t("container title") }}</label>
      <input type="text" name="image" v-model="image" />
    </div>
    <div class="field">
      <label for="">{{ $t("vue component name") }}</label>
      <input type="text" name="description" v-model="description" />
    </div>
    <div class="field">
      <label for="">{{ $t("container icon") }}</label>
      <input type="text" name="description" v-model="description" />
    </div>
    <div class="field">
      <label for="">{{ $t("element modal name") }}</label>
      <input type="text" name="index_route" v-model="index_route" />
    </div>
    <div class="field">
      <label for="">{{ $t("relative configure component modal path") }}</label>
      <input
        type="text"
        name="configure_component"
        v-model="configure_component"
      />
    </div>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import { local_api } from "@/utils";

export default {
  name: "SettingsModuleModalGeneral",
  data() {
    return {
      name: "module name",
      image: "/images/icons/module_image.png",
      description: "module description",
      index_route: "ModuleRouter",
      configure_component: "module_path/configuration_modal/Index",
      form: undefined,
    };
  },
  methods: {
    init_form() {
      let vm = this;
      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          image: ["empty"],
          description: ["empty"],
          index_route: ["empty"],
        },
      });
    },
    is_valid() {
      let vm = this;
      return vm.form.form("validate form");
    },
    reset_form() {
      let vm = this;
      vm.form.form("reset");
    },
    create_module() {
      let vm = this;
      return new Promise((resolve, reject) => {
        local_api(vm, "post", "/system/do-create-module", {
          n: vm.name,
          i: vm.image,
          d: vm.description,
          r: vm.index_route,
          c: vm.configure_component,
        })
          .then((r) => {
            resolve(r);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>
